import type { IconDefinition } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin, faXTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Farcaster } from "~/components/logos/farcaster";
import { ExternalLink } from "~/components/site/external-link";

type Props = Readonly<{
  twitterUrl?: string;
  linkedInUrl?: string;
  farcasterUrl?: string;
}>;

export function SocialDiscussions({
  twitterUrl,
  linkedInUrl,
  farcasterUrl,
}: Props): JSX.Element | null {
  if (!twitterUrl && !linkedInUrl && !farcasterUrl) {
    return null;
  }

  return (
    <div>
      <h3 className="text-xl mt-12 mb-6">Discuss on</h3>
      <div className="not-prose text-primary flex flex-col sm:flex-row gap-y-2 sm:gap-y-0 sm:gap-x-6">
        {twitterUrl && (
          <DiscussionLink
            icon={faXTwitter}
            link={twitterUrl}
            text="X (Twitter)"
          />
        )}
        {linkedInUrl && (
          <DiscussionLink
            icon={faLinkedin}
            link={linkedInUrl}
            text="LinkedIn"
          />
        )}
        {farcasterUrl && (
          <DiscussionLink
            icon={<Farcaster />}
            link={farcasterUrl}
            text="Farcaster"
          />
        )}
      </div>
    </div>
  );
}

type DiscussionLinkParams = Readonly<{
  icon: IconDefinition | JSX.Element;
  link: string;
  text: string;
}>;

function DiscussionLink({ icon, link, text }: DiscussionLinkParams) {
  return (
    <ExternalLink
      className="flex items-center justify-center gap-x-3 py-3 px-4 grow border border-primary hover:border-gray-400 hover:dark:border-gray-600 rounded-full whitespace-nowrap global-hover-transition"
      href={link}
    >
      {typeof icon === "object" && "iconName" in icon ? (
        <FontAwesomeIcon className="h-5 w-5" icon={icon} />
      ) : (
        <Farcaster className="h-5 w-5" />
      )}
      <span>{text}</span>
    </ExternalLink>
  );
}
